"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SsoButtonWrapper = exports.SsoButton = exports.SkeletonContainer = exports.SkeletonBase = exports.Row = exports.MessageContainer = exports.HeadRow = exports.Container = exports.Columns = exports.Card = exports.Button = exports.Bars = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const SkeletonContainer = exports.SkeletonContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "SkeletonContainer",
  class: "pl-s1f7vrp8"
});
const MessageContainer = exports.MessageContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "MessageContainer",
  class: "pl-m4giylz"
});
const Bars = exports.Bars = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Bars",
  class: "pl-b36pqei"
});
const SkeletonBase = exports.SkeletonBase = /*#__PURE__*/(0, _react.styled)("div")({
  name: "SkeletonBase",
  class: "pl-s1561y1d"
});
const Container = exports.Container = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Container",
  class: "pl-c7787tl"
});
const Card = exports.Card = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Card",
  class: "pl-cna5kjt"
});
const HeadRow = exports.HeadRow = /*#__PURE__*/(0, _react.styled)(SkeletonBase)({
  name: "HeadRow",
  class: "pl-h7zqs1x"
});
const Row = exports.Row = /*#__PURE__*/(0, _react.styled)(SkeletonBase)({
  name: "Row",
  class: "pl-rhwq0ga"
});
const Button = exports.Button = /*#__PURE__*/(0, _react.styled)(SkeletonBase)({
  name: "Button",
  class: "pl-b1fe0f71"
});
const SsoButtonWrapper = exports.SsoButtonWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "SsoButtonWrapper",
  class: "pl-s1rufv72"
});
const SsoButton = exports.SsoButton = /*#__PURE__*/(0, _react.styled)(SkeletonBase)({
  name: "SsoButton",
  class: "pl-s1urlys"
});
const Columns = exports.Columns = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Columns",
  class: "pl-cn2u42x"
});